// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"803":"66096e61","5344":"a8aeb788","8528":"68ad8410"}[chunkId] + ".chunk.css";
};